export const PRESET_RATIO = {
  square: "aspect-[1/1]",
  portrait: "aspect-[3/4]",
  tall: "aspect-[2/3]",
  landscape: "aspect-[4/3]",
  wide: "aspect-[16/9]",
  ultrawide: "aspect-[21/9]",
  long: "aspect-[2/1]",
  "very-long": "aspect-[4/1]",
} as const;
